<section class="pks-bursa-hero tw-overflow-hidden tw-bg-white">
  <div class="pks-bursa-fullbleed tw-relative tw-px-0">
    <div class="pks-bursa-hero__panel">
      <div
        class="tw-mx-auto tw-grid tw-max-w-[1280px] tw-grid-cols-1 tw-items-center tw-gap-10 tw-px-6 tw-py-12 lg:tw-grid-cols-2 lg:tw-px-10 lg:tw-py-16"
      >
        <div class="tw-relative tw-z-[1]">
          <div class="tw-mb-6">
            <span
              class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-divider tw-bg-white tw-px-4 tw-py-1 tw-text-xs tw-font-medium tw-text-body-dark"
            >
              SME Corporation Malaysia – Capital Market Catalyst Programme
            </span>
          </div>

          <h1 class="tw-m-0 tw-text-4xl tw-font-extrabold tw-leading-tight lg:tw-text-6xl">
            <span>Elevate Your Business:</span>
            <br />
            <span class="tw-font-light tw-italic">From SME to</span>
            <span class="tw-font-extrabold tw-not-italic tw-text-[#0BA7B6]">
              Public Listed Powerhouse.</span
            >
          </h1>

          <p
            class="tw-mt-6 tw-max-w-xl tw-text-[23px] tw-leading-relaxed tw-text-body-dark tw-opacity-80"
          >
            Unlock the capital you need to scale. PKS&#64;Bursa provides the funding, mentorship,
            and roadmap to get your company listed on Bursa Malaysia.
          </p>

          <div class="tw-mt-8 tw-flex tw-flex-wrap tw-items-center tw-gap-3">
            <a
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
              target="_blank"
              rel="noreferrer"
            >
              Apply Now
              <span aria-hidden="true">→</span>
            </a>

            <button
              type="button"
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-divider tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-body-dark hover:tw-bg-divider hover:tw-bg-opacity-50 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              (click)="scrollToRoadmap()"
            >
              View the Roadmap
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>

        <div></div>
      </div>
    </div>

    <div class="pks-bursa-ticker tw-w-full tw-bg-black tw-py-2">
      <div
        class="pks-bursa-ticker__track tw-flex tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-white tw-text-opacity-90"
      >
        <div class="pks-bursa-ticker__item tw-pr-10">
          Cohort intake is limited. Roadshows begin June 2026. Register your interest today.
          <span class="tw-text-[#0BA7B6]">*Early applicants will be prioritised*</span>
        </div>
        <div class="pks-bursa-ticker__item tw-pr-10">
          Cohort intake is limited. Roadshows begin June 2026. Register your interest today.
          <span class="tw-text-[#0BA7B6]">*Early applicants will be prioritised*</span>
        </div>
        <div class="pks-bursa-ticker__item tw-pr-10">
          Cohort intake is limited. Roadshows begin June 2026. Register your interest today.
          <span class="tw-text-[#0BA7B6]">*Early applicants will be prioritised*</span>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="pks-bursa-gateway tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 lg:tw-px-10">
      <div
        class="pks-bursa-gateway__stats tw-grid tw-grid-cols-1 tw-gap-6 tw-border-b tw-border-solid tw-border-divider tw-py-10 md:tw-grid-cols-3 md:tw-gap-0"
      >
        <div
          class="tw-text-center md:tw-border-r md:tw-border-solid md:tw-border-divider md:tw-px-6"
        >
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">RM2M–5M</div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            Financing Loan
          </div>
        </div>
        <div
          class="tw-text-center md:tw-border-r md:tw-border-solid md:tw-border-divider md:tw-px-6"
        >
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">5%</div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            Fixed Rate
          </div>
        </div>
        <div class="tw-text-center md:tw-px-6">
          <div class="tw-text-3xl tw-font-extrabold tw-text-[#0BA7B6] md:tw-text-4xl">IPO</div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            From IPO-ready to public listed
          </div>
          <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-body-dark tw-opacity-70">
            with support every step of the way
          </div>
        </div>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-10 tw-py-12 lg:tw-grid-cols-12 lg:tw-py-16">
        <div class="lg:tw-col-span-12">
          <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
            <span>Your Gateway to</span>
            <span class="tw-text-[#0BA7B6]"> Capital Markets</span>
          </h2>

          <div
            class="tw-mt-6 tw-max-w-none tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-80"
          >
            <p class="tw-mb-4">
              PKS&#64;Bursa is a strategic initiative by SME Corporation Malaysia designed to
              catalyse high-potential SMEs toward public listing on Bursa Malaysia.
            </p>
            <p class="tw-m-0">
              The programme bridges the gap between private ownership and public growth, equipping
              business owners with the financial tools, governance knowledge, and institutional
              support needed to confidently step into Malaysia’s capital markets.
            </p>
          </div>

          <ul class="pks-bursa-gateway__bullets tw-mt-8 tw-space-y-3 tw-pl-0">
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark">
                Government-backed programme with structured support
              </span>
            </li>
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark"
                >De-risk the IPO process with expert mentorship</span
              >
            </li>
            <li class="tw-flex tw-items-start tw-gap-3">
              <span class="pks-bursa-gateway__check" aria-hidden="true"></span>
              <span class="tw-text-[20px] tw-text-body-dark"
                >Join Malaysia’s most prestigious business community</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="pks-bursa-pillars tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-text-left">
        <h2
          class="tw-m-0 tw-text-left tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl"
        >
          <span>Everything You Need to</span>
          <br />
          <span class="tw-text-[#0BA7B6]">List with Confidence</span>
        </h2>
        <div
          class="tw-mt-3 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
        >
          The Three Pillars of Success
        </div>
      </div>

      <div class="pks-bursa-pillars__block tw-mt-10">
        <div class="pks-bursa-pillars__cols">
          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Pillar 01</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Growth Capital
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Financial Fuel
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              Access a minimum of RM2 million and up to RM5 million in financing at a highly
              competitive 5% fixed rate. You don't need to absorb the upfront cost of your listing
              journey. Capital is never a barrier.
            </p>
            <div class="pks-bursa-pillars__metric">RM2M-RM5M</div>
          </div>

          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Pillar 02</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Listing Business Mentorship
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Expert Guidance
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              You don’t do this alone. Our capacity-building programme pairs your leadership team
              with specialists in Corporate Governance Excellence, financial reporting, and investor
              relations readiness.
            </p>
            <div class="pks-bursa-pillars__metric">Dedicated Mentor</div>
          </div>

          <div class="pks-bursa-pillars__col">
            <div class="pks-bursa-pillars__pill">Pillar 03</div>
            <div class="tw-mt-4 tw-text-[22px] tw-font-extrabold tw-text-body-dark">
              Market Recognition
            </div>
            <div
              class="tw-mt-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-50"
            >
              Prestige of Listing
            </div>
            <p class="tw-mt-5 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
              Access to experienced capital market advisors through advisory partners, guiding you
              on corporate governance, financial compliance, investor relations and IPO structuring.
            </p>
            <div class="pks-bursa-pillars__metric">Bursa Malaysia</div>
          </div>
        </div>
      </div>

      <div class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-3">
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pkspeople.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            pitchIN’s 50,000-Strong Investor Network
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Your future shareholders are already registered on Malaysia’s #1 ECF platform.
          </p>
        </div>
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pksarrow.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            PSTX Secondary Market Access
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            The only programme that gives pre-IPO companies access to Malaysia’s first private share
            secondary market for validated price discovery.
          </p>
        </div>
        <div class="pks-bursa-pillars__mini tw-bg-white tw-p-8">
          <img
            src="/assets/img/icons/svgs/pksbook.svg"
            alt=""
            class="pks-bursa-pillars__mini-icon"
          />
          <div class="tw-text-[21px] tw-font-extrabold tw-text-body-dark">
            Professional Advisory Services
          </div>
          <p class="tw-mt-3 tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Access to experienced capital market advisors through Advisory Partners, guiding you on
            corporate governance, financial compliance, investor relations and IPO structuring.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section id="pks-bursa-roadmap" class="pks-bursa-steps tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-max-w-[1100px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="pks-bursa-steps__grid tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-gap-12">
        <div>
          <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
            <span>From Application to</span>
            <span class="tw-text-[#0BA7B6]"> Listing Day</span>
          </h2>
          <p
            class="tw-mt-4 tw-max-w-xl tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
          >
            A structured, supported pathway from where you are today to where your business deserves
            to be.
          </p>

          <ol class="pks-bursa-steps__list tw-mt-8 tw-space-y-6 tw-pl-0">
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">1</div>
              <div>
                <div class="pks-bursa-steps__step">Step 1</div>
                <div class="pks-bursa-steps__title">Application</div>
                <div class="pks-bursa-steps__desc">
                  Submit your application in the link below. Our team reviews your profile.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">2</div>
              <div>
                <div class="pks-bursa-steps__step">Step 2</div>
                <div class="pks-bursa-steps__title">Assessment</div>
                <div class="pks-bursa-steps__desc">
                  We evaluate your SCORE certification status, MSME status, and listing readiness
                  against programme criteria, ensuring PKS&#64;Bursa is the right fit for your
                  business.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">3</div>
              <div>
                <div class="pks-bursa-steps__step">Step 3</div>
                <div class="pks-bursa-steps__title">Capacity Building</div>
                <div class="pks-bursa-steps__desc">
                  12 weeks of intensive in-person modules in KL, covering governance, financial
                  compliance and investor communication.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">4</div>
              <div>
                <div class="pks-bursa-steps__step">Step 4</div>
                <div class="pks-bursa-steps__title">Pre-IPO Readiness</div>
                <div class="pks-bursa-steps__desc">
                  A structured programme that prepares your business for listing, covering corporate
                  restructuring, compliance, due diligence and investor relations.
                </div>
              </div>
            </li>
            <li class="pks-bursa-steps__item">
              <div class="pks-bursa-steps__no">5</div>
              <div>
                <div class="pks-bursa-steps__step">Step 5</div>
                <div class="pks-bursa-steps__title">Listing Day</div>
                <div class="pks-bursa-steps__desc">
                  Ring the bell. Your company joins the ranks of Malaysia’s publicly listed
                  enterprises.
                </div>
              </div>
            </li>
          </ol>
        </div>

        <div>
          <div class="pks-bursa-steps__art tw-mx-auto tw-max-w-[520px] lg:tw-ml-auto lg:tw-mr-0">
            <img
              src="/assets/img/banner/people-01%201.png"
              alt=""
              class="pks-bursa-steps__person"
            />
          </div>
        </div>
      </div>

      <div
        class="pks-bursa-steps__howto tw-mx-auto tw-mt-12 tw-max-w-[920px] tw-rounded-xl tw-bg-[#8A7A45] tw-p-10 tw-text-white"
      >
        <div
          class="tw-text-[20px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-white tw-text-opacity-80"
        >
          How to Apply:
        </div>

        <div class="tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-3">
          <div>
            <div class="tw-text-[18px] tw-font-bold">01&nbsp; Register Your Interest</div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              Complete the application form. Tell us about your business, your goals, and your
              current stage.
            </div>
          </div>
          <div>
            <div class="tw-text-[18px] tw-font-bold">02&nbsp; Attend a Roadshow or Screening</div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              We’re coming to you. Join us in JB, Penang, KL, Sabah or Sarawak — or request a
              virtual session.
            </div>
          </div>
          <div>
            <div class="tw-text-[18px] tw-font-bold">03&nbsp; Get Selected</div>
            <div class="tw-mt-2 tw-text-[16px] tw-leading-relaxed tw-text-white tw-text-opacity-80">
              Shortlisted companies join our Pre-IPO Accelerator cohort beginning September 2026.
            </div>
          </div>
        </div>

        <div class="tw-mt-8 tw-grid tw-grid-cols-1 tw-items-end tw-gap-6 lg:tw-grid-cols-2">
          <div class="tw-text-[16px] tw-text-white tw-text-opacity-80">
            <div class="tw-font-bold">Applications for the 2026 cohort are now open.</div>
            <div class="tw-text-white tw-text-opacity-60">
              Intake is limited — early applicants are prioritised.
            </div>
          </div>

          <div class="tw-flex lg:tw-justify-end">
            <a
              class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#0BA7B6] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-opacity-90 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
              href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
              target="_blank"
              rel="noreferrer"
            >
              Apply Now
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-ready tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="pks-bursa-ready__header tw-max-w-[920px]">
        <h2
          class="tw-m-0 tw-text-left tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl"
        >
          <span>Are You</span>
          <span class="tw-text-[#0BA7B6]"> Ready to List?</span>
        </h2>
        <p
          class="tw-mt-4 tw-w-full tw-text-left tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          Tick all boxes to self-qualify. If you can check every item below, PKS&#64;Bursa was built
          for you.
        </p>
      </div>

      <div
        class="pks-bursa-ready__grid tw-mt-10 tw-grid tw-max-w-[920px] tw-grid-cols-1 tw-gap-10 lg:tw-gap-12"
      >
        <div class="tw-w-full tw-space-y-3 lg:tw-max-w-[520px]">
          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no">01</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  MSME Status — Certified Malaysian MSME
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Your business must be registered and certified Malaysian MSME.
                </div>
                <a
                  class="pks-bursa-ready__link"
                  href="https://mybpi.smecorp.gov.my/Registration/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Apply or verify here <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>

          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no">02</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  SCORE Star Rating — 3 Stars or Above
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Your business must have a SCORE rating of at least 3 stars from SME Corp.
                  Malaysia.
                </div>
                <a
                  class="pks-bursa-ready__link"
                  href="https://mybpi.smecorp.gov.my/Registration/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Apply for SCORE Rating <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>

          <div class="pks-bursa-ready__card tw-bg-white tw-p-5">
            <div class="tw-flex tw-gap-4">
              <div class="pks-bursa-ready__no pks-bursa-ready__no--muted">03</div>
              <div class="tw-min-w-0">
                <div class="tw-text-[20px] tw-font-extrabold tw-text-body-dark">
                  Viable Track Record
                </div>
                <div
                  class="tw-mt-1 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
                >
                  Demonstrated operational history and financials available.
                </div>
              </div>
            </div>
          </div>

          <p class="tw-mt-5 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-60">
            The PKS&#64;Bursa programme is specifically designed for SMEs that have already
            demonstrated excellence through their SCORE certification and MSME registration. If you
            meet these standards, you are ready to take the next step.
          </p>

          <a
            class="tw-mt-4 tw-inline-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
            target="_blank"
            rel="noreferrer"
          >
            Apply Now
            <span aria-hidden="true">→</span>
          </a>
        </div>

        <div class="pks-bursa-ready__side">
          <div class="pks-bursa-ready__panel tw-rounded-xl tw-bg-[#0BA7B6] tw-p-7 tw-text-white">
            <div class="tw-text-[20px] tw-font-extrabold">Not sure if you qualify?</div>
            <p class="tw-mt-2 tw-text-[20px] tw-leading-relaxed tw-text-white tw-text-opacity-90">
              Attend one of our roadshows and speak to our team directly. We’ll help you assess your
              readiness with no obligation.
            </p>

            <div class="tw-mt-6 tw-text-[20px] tw-font-extrabold">Roadshow Dates</div>
            <ul class="tw-mt-4 tw-space-y-3 tw-pl-0">
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[20px]">
                <a
                  class="tw-flex tw-w-full tw-items-center tw-justify-between tw-text-white tw-no-underline hover:tw-text-white hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-[#0BA7B6]"
                  href="https://luma.com/fzeylv7q"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="tw-flex tw-items-center tw-gap-2">
                    <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                    Johor Bahru
                  </span>
                  <span class="tw-text-white tw-text-opacity-80">30 Jun, Tue</span>
                </a>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[20px]">
                <a
                  class="tw-flex tw-w-full tw-items-center tw-justify-between tw-text-white tw-no-underline hover:tw-text-white hover:tw-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-[#0BA7B6]"
                  href="https://luma.com/30118sac?tk=TzwfPF"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span class="tw-flex tw-items-center tw-gap-2">
                    <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                    Penang
                  </span>
                  <span class="tw-text-white tw-text-opacity-80">24 Jul, Fri</span>
                </a>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[20px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kuala Lumpur
                </span>
                <span class="tw-text-white tw-text-opacity-80">Date: TBC</span>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[20px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kota Kinabalu
                </span>
                <span class="tw-text-white tw-text-opacity-80">6 Aug, Thu</span>
              </li>
              <li class="tw-flex tw-items-center tw-justify-between tw-text-[20px]">
                <span class="tw-flex tw-items-center tw-gap-2">
                  <span class="pks-bursa-ready__dot" aria-hidden="true"></span>
                  Kuching
                </span>
                <span class="tw-text-white tw-text-opacity-80">10 Aug, Mon</span>
              </li>
            </ul>
          </div>

          <div class="pks-bursa-ready__art tw-relative">
            <img
              src="/assets/img/banner/people-02%201.png"
              alt=""
              class="pks-bursa-ready__person"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-compare tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
        <span>Life Before Listing</span>
        <br />
        <span class="tw-text-[#0BA7B6]">vs. Life After Listing</span>
      </h2>

      <div
        class="tw-mt-10 tw-overflow-x-auto tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white"
      >
        <table class="tw-w-full tw-min-w-[820px] tw-border-collapse">
          <thead>
            <tr class="tw-bg-[#f3f4f6]">
              <th
                class="tw-w-[22%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                Aspect
              </th>
              <th
                class="tw-w-[39%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                Before Listing
              </th>
              <th
                class="tw-w-[39%] tw-px-6 tw-py-4 tw-text-left tw-text-[16px] tw-font-extrabold tw-uppercase tw-tracking-[0.2em] tw-text-body-dark tw-opacity-60"
              >
                POST-LISTING
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Capital Access
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Limited to bank loans &amp; personal savings
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Unlock equity capital markets &amp; institutional investors
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Brand Recognition
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Local or regional market presence
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                National visibility on Bursa Malaysia
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Corporate Governance
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Informal processes, manual oversight
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                International-standard governance frameworks
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Shareholder Value
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Illiquid private ownership
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Tradeable shares with market-determined valuation
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Investor Network
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Limited to personal network
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Exposure to institutional &amp; retail investor community
              </td>
            </tr>
            <tr class="tw-border-t tw-border-solid tw-border-divider">
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-semibold tw-text-body-dark">
                Business Credibility
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#C0176B]">
                Perceived as a private SME
              </td>
              <td class="tw-px-6 tw-py-4 tw-text-[20px] tw-font-medium tw-text-[#0BA7B6]">
                Recognised public listed company
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-faq tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
        <span>Frequently Asked</span>
        <span class="tw-text-[#0BA7B6]"> Questions</span>
      </h2>

      <div class="tw-mt-10 tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-2 lg:tw-gap-14">
        <div class="tw-space-y-10">
          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">What is PKS&#64;Bursa?</div>
            <div class="pks-bursa-faq__a">
              A national SME-to-IPO programme by SME Corp. Malaysia, delivered by pitchIN, designed
              to take high-potential businesses all the way to a Bursa Malaysia listing.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">What funding is available?</div>
            <div class="pks-bursa-faq__a">
              Selected companies may access soft financing at 5% fixed rate.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">How long does the programme take?</div>
            <div class="pks-bursa-faq__a">
              Phase 1 (Accelerator) is 12 weeks. Phase 2 (IPO Readiness) is 12–36 months depending
              on your company's stage. Phase 3 continues through to your listing day.
            </div>
          </div>
        </div>

        <div class="tw-space-y-10">
          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Do I need to be based in KL?</div>
            <div class="pks-bursa-faq__a">
              No. We’re running roadshows in JB, Penang, KL, Sabah and Sarawak in 2026 with more
              cities to come in 2027.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">
              How is PKS&#64;Bursa different from other programmes?
            </div>
            <div class="pks-bursa-faq__a">
              Most programmes prepare you for an IPO. PKS&#64;Bursa takes you there with real
              capital, a secondary market for price discovery and an advisory team that stays with
              you through listing day.
            </div>
          </div>

          <div class="pks-bursa-faq__item">
            <div class="pks-bursa-faq__q">Who do I contact?</div>
            <div class="pks-bursa-faq__a">
              Visit one of our roadshows or email us at
              <a class="pks-bursa-faq__link" href="mailto:pksbursa@pitchin.my">
                pksbursa&#64;pitchin.my
              </a>
              . You can also drop us a WhatsApp at
              <a
                class="pks-bursa-faq__link"
                href="https://wa.me/60102108074"
                target="_blank"
                rel="noreferrer"
              >
                +6010 210 8074
              </a>
              .
            </div>
          </div>
        </div>
      </div>

      <div class="pks-bursa-faq__art tw-mx-auto tw-mt-14 tw-max-w-[640px]">
        <img src="/assets/img/banner/people-03%201.png" alt="" class="pks-bursa-faq__people" />
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-case tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-w-full tw-text-left">
        <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
          <span>The Case for</span>
          <span class="tw-text-[#0BA7B6]"> Listing Now</span>
        </h2>
        <p
          class="tw-mt-4 tw-max-w-full tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          PKS&#64;Bursa is designed to de-risk the IPO process and bridge the gap between private
          ownership and public growth for Malaysia’s most promising SMEs.
        </p>
      </div>

      <div class="tw-mt-10 tw-grid tw-w-full tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-3">
        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Lower Barriers
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            PKS&#64;Bursa helps absorb the initial costs and complexities of going public. We
            de-risk the IPO process so you can focus on growth.
          </p>
        </div>

        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M4 19v-7"></path>
              <path d="M12 19V5"></path>
              <path d="M20 19v-11"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Structured Growth
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Align your internal systems with international corporate standards. We provide the
            roadmap, you execute the vision.
          </p>
        </div>

        <div class="tw-rounded-xl tw-border tw-border-solid tw-border-divider tw-bg-white tw-p-7">
          <div
            class="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#0BA7B6] tw-bg-opacity-10"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0BA7B6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="8" r="3"></circle>
              <path d="M19 21H5a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4z"></path>
            </svg>
          </div>
          <div class="tw-mt-5 tw-text-[20px] tw-font-extrabold tw-text-[#0BA7B6]">
            Market Recognition
          </div>
          <p class="tw-mt-3 tw-text-[18px] tw-leading-relaxed tw-text-body-dark tw-opacity-70">
            Join the ranks of Malaysia’s top-performing companies on the national exchange. Be part
            of the country’s economic growth story.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pks-bursa-join tw-bg-[#f6f6f4]">
  <div class="container-fluid tw-px-0">
    <div class="tw-mx-auto tw-max-w-[1280px] tw-px-6 tw-py-14 lg:tw-px-10 lg:tw-py-20">
      <div class="tw-text-center">
        <h2 class="tw-m-0 tw-text-3xl tw-font-extrabold tw-leading-tight md:tw-text-4xl">
          Ready to Join Bursa Malaysia?
        </h2>
        <p
          class="tw-mx-auto tw-mt-4 tw-max-w-xl tw-text-[20px] tw-leading-relaxed tw-text-body-dark tw-opacity-70"
        >
          Apply today and take your business to the next level. Our team will guide you from your
          first application through to your listing day.
        </p>

        <div
          class="tw-mt-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 sm:tw-flex-row"
        >
          <a
            class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-bg-[#C0176B] tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-[#A41459] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://forms.clickup.com/9008241541/f/8cexpw5-99476/4EH0H5XUAZ5JU08L03"
            target="_blank"
            rel="noreferrer"
          >
            Apply Now
            <span aria-hidden="true">→</span>
          </a>
          <a
            class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-[#C0176B] tw-bg-transparent tw-px-6 tw-py-3 tw-text-sm tw-font-semibold tw-text-[#C0176B] hover:tw-bg-[#C0176B] hover:tw-text-white focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0BA7B6] focus-visible:tw-ring-offset-2"
            href="https://smecorp.gov.my/"
            target="_blank"
            rel="noreferrer"
          >
            Visit SME Corp
            <span aria-hidden="true">↗</span>
          </a>
        </div>

        <div class="tw-mt-8 tw-text-xs tw-text-body-dark tw-opacity-70">
          Questions? Contact us at
          <a
            class="pks-bursa-faq__link tw-font-semibold"
            href="https://wa.me/60102108074"
            target="_blank"
            rel="noreferrer"
          >
            +6010 210 8074
          </a>
        </div>
      </div>

      <div
        class="pks-bursa-join__footer tw-mt-12 tw-border-t tw-border-solid tw-border-divider tw-pt-10"
      >
        <div class="tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-12 lg:tw-items-center">
          <div class="lg:tw-col-span-3">
            <div class="tw-text-xs tw-leading-relaxed tw-text-body-dark tw-opacity-60">
              PKS&#64;Bursa is a programme by SME Corporation Malaysia, officially delivered by
              pitchIN (Pitch Platforms Sdn Bhd), a registered Recognised Market Operator by
              Securities Commission Malaysia.
            </div>
          </div>

          <div class="lg:tw-col-span-6">
            <div
              class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-6 md:tw-max-w-[520px] md:tw-flex-row md:tw-justify-center md:tw-gap-20"
            >
              <div class="tw-flex tw-min-h-[110px] tw-flex-col tw-items-center tw-py-2">
                <div
                  class="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
                >
                  Powered by
                </div>
                <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
                  <img
                    src="/assets/img/banner/logo_SME%205.png"
                    alt="SME Corp"
                    class="tw-h-[46px] tw-w-auto tw-object-contain"
                    loading="lazy"
                  />
                </div>
              </div>

              <div class="tw-flex tw-min-h-[110px] tw-flex-col tw-items-center tw-py-2">
                <div
                  class="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.25em] tw-text-body-dark tw-opacity-50"
                >
                  Delivery Partner
                </div>
                <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center">
                  <img
                    src="/assets/img/banner/pitchin-logo%201.png"
                    alt="pitchIN"
                    class="tw-h-[68px] tw-w-auto tw-object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="lg:tw-col-span-3 lg:tw-text-right">
            <div class="tw-space-y-1 tw-text-xs tw-text-body-dark tw-opacity-80">
              <div>
                Email:
                <a class="pks-bursa-faq__link" href="mailto:pksbursa@pitchin.my"
                  >pksbursa&#64;pitchin.my</a
                >
              </div>
              <div>
                Phone:
                <a
                  class="pks-bursa-faq__link"
                  href="https://wa.me/60102108074"
                  target="_blank"
                  rel="noreferrer"
                >
                  +6010 210 8074
                </a>
              </div>
              <div class="tw-text-body-dark tw-opacity-60">
                Roadshows: JB · Penang · KL · KK · Kuching
              </div>
            </div>
          </div>
        </div>

        <div
          class="tw-mt-10 tw-border-t tw-border-solid tw-border-divider tw-pt-6 tw-text-center tw-text-[11px] tw-text-body-dark tw-opacity-50"
        >
          © 2026 PKS&#64;Bursa · SME Corporation Malaysia &amp; pitchIN · All rights reserved
        </div>
      </div>
    </div>
  </div>
</section>
